var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9952 10.9951C15.1826 11.1826 15.288 11.4369 15.288 11.7021C15.288 11.9672 15.1826 12.2215 14.9952 12.4091L10.4022 17.0021C10.2159 17.1846 9.96506 17.2863 9.70424 17.285C9.44341 17.2837 9.19364 17.1795 9.0092 16.995C8.82476 16.8106 8.72057 16.5608 8.71925 16.3C8.71793 16.0392 8.8196 15.7884 9.00217 15.6021L12.9022 11.7021L9.00217 7.80207C8.8196 7.61578 8.71793 7.36497 8.71925 7.10414C8.72057 6.84331 8.82477 6.59354 9.0092 6.4091C9.19364 6.22467 9.44341 6.12047 9.70424 6.11915C9.96507 6.11784 10.2159 6.21951 10.4022 6.40207L14.9952 10.9951Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.144ff66402d0e246f191f5571d0f7865.svg";
export { ForwardRef as ReactComponent };